import React from 'react'
import { Outlet } from 'react-router-dom'

const WithoutGuestNav = () => {
  return (
    <Outlet />
  )
}

export default WithoutGuestNav